import * as React from 'react';

import { ITagGroup, IEditProps } from '../types';
import Form from './Form';

export default class Edit extends React.Component<IEditProps> {
  onSubmit = async (values: ITagGroup) => {
    await this.props.update(values);
    this.props.closeRow();
  };

  render() {
    return (
      <Form
        id={this.props.item.id}
        disableName={true}
        initialValues={this.props.item}
        onSubmit={this.onSubmit}
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/TagGroups/components/Edit.tsx